import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider, {
  IApiPaginationData,
} from '../../dataProvider/APIDataProvider';
import { IAdminGetQuestionList, IQuestion } from '../QuestionSlice';
import { ISession } from '.';

const SessionApiDataProvider = new APIDataProvider<ISession>();
const QuestionListApiDataProvider = new APIDataProvider<
  IApiPaginationData<IQuestion>
>();

export const getSessionById = createAsyncThunk(
  'session/id',
  async (id: string) => {
    const response = await SessionApiDataProvider.getById(
      `${UserApiPaths.session}/${id}`
    );
    return response.data;
  }
);

const getQuestionList = async (data: IAdminGetQuestionList) => {
  const response = await QuestionListApiDataProvider.create(
    `${UserApiPaths.session}/list`,
    data
  );

  return response.data as {
    limit: number;
    offset: number;
    totalDocs: number;
    docs: Array<IQuestion>;
  };
};

export const getQuestionListBySubTopic = createAsyncThunk(
  'user/question/list',
  getQuestionList
);

export const loadMoreQuestionListBySubTopic = createAsyncThunk(
  'user/question/loadMore',
  getQuestionList
);
